import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome;

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg font-bold">
            <i className="ri-emotion-happy-line w-6 h-6 flex items-center justify-center"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-hand text-2xl md:text-[28px] transition-colors ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              {site.name}
            </span>
            <span
              className={`text-[10px] tracking-[0.3em] mt-0.5 transition-colors ${
                solid ? "text-foreground-500" : "text-background-200"
              }`}
            >
              GUATIAN
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm transition-colors ${
                  isActive
                    ? "text-primary-600 font-medium"
                    : solid
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-100 hover:text-background-50"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/chat"
            className="hidden md:inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-chat-smile-2-line w-4 h-4 flex items-center justify-center"></i>
            进聊天室
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className={`md:hidden w-10 h-10 rounded-md flex items-center justify-center text-xl transition-colors ${
              solid ? "text-foreground-900 bg-background-100" : "text-background-50 bg-foreground-950/30"
            }`}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-5 pt-2">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm border-b border-background-100 last:border-0 ${
                    isActive ? "text-primary-600 font-medium" : "text-foreground-700"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/chat"
            className="mt-3 flex items-center justify-center gap-1.5 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium"
          >
            <i className="ri-chat-smile-2-line w-4 h-4 flex items-center justify-center"></i>
            进聊天室蹲后续
          </Link>
        </div>
      ) : null}
    </header>
  );
}